import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import { CssBaseline, ThemeProvider } from "@mui/material";
import Navbar from "./components/Navbar";
import Home from "./pages/Home";
import Login from "./pages/Login";
import Register from "./pages/Register";
import SignUp from "./pages/Signup";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import Footer from "./components/Footer";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import TCCallback from "./pages/tc/page";
import LoginSso from "./pages/login/sso/page";
import Terms from "./pages/terms/page";
import PrivacyPolicy from "./pages/privacyPolicy/page";
import ActivateAccount from "./pages/ActivateAccount/page";
import PageNotFound from "./components/PageNotFound";

// Import dashboard
import DashboardLayout from "./components/layout/Layout";
import DashboardPage from "./pages/Dashboard/index";
import ProfilePage from "./pages/Dashboard/views/profile";

import TaskConnectPage from "./pages/Dashboard/views/TaskConnect";
import WageConnectPage from "./pages/Dashboard/views/WageConnect";
import ChatConnectPage from "./pages/Dashboard/views/ChatConnect";
import ShiftConnectPage from "./pages/Dashboard/views/ShiftConnect";
import BookConnectPage from "./pages/Dashboard/views/BookConnect";
import ClientConnectPage from "./pages/Dashboard/views/ClientConnect";
import MemberConnectPage from "./pages/Dashboard/views/MemberConnect";
import AuthRoute, { PublicRoute } from "./auth/AuthRoute";
import theme from "./theme";

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        {/* Navbar tidak ditampilkan untuk rute dashboard */}
        <Routes>
          <Route path="/dashboard/*" element={<DashboardRoutes />} />
          <Route path="*" element={<MainRoutes />} />
        </Routes>
      </Router>
    </ThemeProvider>
  );
}

// Rute untuk landing page dan auth
const MainRoutes = () => {
  const { pathname } = useLocation();

  const hideNavbarAndFooter = [
    "/login",
    "/register",
    "/sign-up",
    "/ForgotPassword",
    "/reset-password",
    "/login/sso",
    "/activate-account",
  ];
  const shouldHideLayout = hideNavbarAndFooter.includes(pathname);

  return (
    <>
      {!shouldHideLayout && <Navbar />}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route
          path="/login"
          element={
            <PublicRoute>
              <Login />
            </PublicRoute>
          }
        />
        <Route
          path="/register"
          element={
            <PublicRoute>
              <Register />
            </PublicRoute>
          }
        />
        <Route
          path="/sign-up"
          element={
            <PublicRoute>
              <SignUp />
            </PublicRoute>
          }
        />
        <Route
          path="/ForgotPassword"
          element={
            <PublicRoute>
              <ForgotPassword />
            </PublicRoute>
          }
        />
        <Route
          path="/reset-password"
          element={
            <PublicRoute>
              <ResetPassword />
            </PublicRoute>
          }
        />
        <Route path="/tc/callback" element={<TCCallback />} />
        <Route
          path="/login/sso"
          element={
            <PublicRoute>
              <LoginSso />
            </PublicRoute>
          }
        />
        <Route
          path="/activate-account"
          element={
            <PublicRoute>
              <ActivateAccount />
            </PublicRoute>
          }
        />
        <Route path="/term-conditions" element={<Terms />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        {/* Add catch-all route for 404 */}
        <Route path="*" element={<PageNotFound />} />
      </Routes>
      {!shouldHideLayout && <Footer />}
    </>
  );
};

// Rute untuk dashboard (protected)
const DashboardRoutes = () => (
  <AuthRoute>
    <DashboardLayout>
      <Routes>
        <Route path="/" element={<DashboardPage />} />
        <Route path="/profile" element={<ProfilePage />} />
        <Route path="/task-connect" element={<TaskConnectPage />} />
        <Route path="/wage-connect" element={<WageConnectPage />} />
        <Route path="/chat-connect" element={<ChatConnectPage />} />
        <Route path="/shift-connect" element={<ShiftConnectPage />} />
        <Route path="/book-connect" element={<BookConnectPage />} />
        <Route path="/client-connect" element={<ClientConnectPage />} />
        <Route path="/member-connect" element={<MemberConnectPage />} />
        {/* Add catch-all route for 404 in dashboard */}
        <Route path="*" element={<PageNotFound />} />
      </Routes>
    </DashboardLayout>
  </AuthRoute>
);

export default App;
